var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",on:{"click":function($event){return _vm.copyShareLink(_vm.shareType, _vm.title, _vm.url)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }